import { render, staticRenderFns } from "./ContechView.vue?vue&type=template&id=2672ee99&scoped=true&"
import script from "./ContechView.vue?vue&type=script&lang=js&"
export * from "./ContechView.vue?vue&type=script&lang=js&"
import style0 from "./ContechView.vue?vue&type=style&index=0&id=2672ee99&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2672ee99",
  null
  
)

export default component.exports